<template>
  <tr class="row-details"> 
    <td colspan="6">
      <div v-if="readyToRender" class="dcv_container">
        <customer v-if="customer" :customer="customer" :is-details="isDetails"></customer>
        <order :order="order" :is-details="isDetails"></order>
        <agency :agency="agency" :is-details="isDetails"></agency>
      </div>
    </td>
  </tr>
</template>

<script>
import api from 'store/api'
import { apiV2 } from 'store/api'
import Type from "./Type"
import Customer from "./ValidationRequestable/CustomerV2"
import Order from "./ValidationRequestable/Order"
import Agency from "./ValidationRequestable/Offer/AgencyV2"

export default {
    name:"DomiciliationContractValidation",

    props:["validationRequestId", "isDetails"],

    components :{
      Order,
      Customer,
      Type,
      Agency,
    },

    data() {
      return {
        validationRequest: null,
        order: null
      }
    },

    computed: {
      validationRequestable() {
        return this.validationRequest.included.validation_requestable
      },

      customer() {
        return this.validationRequest.included.customer
      },

      agency() {
        return this.validationRequestable.included.offer.included.distributed_product.included.agency
      },

      readyToRender(){
        return this.validationRequest != null && this.order != null && this.agency != null
      }
    },

    created() {
      const params = {
        with: 'type,parent_request,child_requests,customer,creating_user,treating_user,validation_requestable.offer.distributed_product.agency.organization,customer_documents'
      }

      apiV2.getValidationRequest(this.validationRequestId, params)
        .then((response) => this.validationRequest = response.data.data)
    },

    watch: {
        validationRequest(newValue, oldValue) {
          if (newValue) {
            api.get_order_with_options({ order_id: this.validationRequestable.relationships.order.data.id })
              .then((response) => this.order = response.data.order)
          }
        }
    }
}
</script>

<style scoped>
.dcv_container {
  display: flex;
  flex-wrap: wrap;
}

.detailed-view {
  border-bottom: solid 1px lightgrey;
  border-left:solid 1px lightgrey;
}

.row-details td {
  background-color: #e0e0e0
}
</style>



// WEBPACK FOOTER //
// client/components/Demands/Details/DomiciliationContractValidation.vue